export const SEND_EMAIL = false;
export const COMPANY_NAME = 'skyniche Technologies';
export const ChatGifApiKey = 'AIzaSyBFaHxqfZL4xpwtA5WnSqXmrUvCvJ2bFzc';

// export const REST_API_END_POINT = 'http://localhost:4000/webservice/';
// export const REST_API = 'http://localhost:4000/';
// export const REST_API_IO = 'http://localhost:4000';
// export const BASE_URL = 'http://localhost:3000/';
// export const DOMAIN = 'localhost';

export const VERSION = '1.56';

export const REST_API_END_POINT = "https://supportcenter.skyniche.website/api/webservice/";
export const REST_API = "https://supportcenter.skyniche.website/api/";
export const REST_API_IO = "https://supportcenter.skyniche.website/api";
export const BASE_URL = "https://supportcenter.skyniche.website/";
export const DOMAIN = 'supportcenter';


//For messenger chat
export const STATUS_OPTIONS = [
  { id: 1, statusData: 'online', label: 'Available' },
  { id: 2, statusData: 'away', label: 'Away' },
  { id: 3, statusData: 'busy', label: 'Busy' },
  { id: 4, statusData: 'invisible', label: 'Invisible' },
  { id: 5, statusData: 'dnd', label: 'Do not disturb' },
];